import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog } from '../../../components/StyledComponents';
import { useLoading } from '../../../context/LoadingContext';
import { deleteDepartment } from '../../../axios/Department/DepartmentApi';
import { deleteLocations } from '../../../axios/Setting/SettingUrlApi';
import { deleteEventsVisitor } from '../../../axios/Visitor/VisitorApi';

const RemoveUserDialog = ({ id, onClose, onRefresh, refreshData, locationData }) => {
   const [show, hide] = useLoading();

   const { t } = useTranslation();

   const handleCloseDialog = () => {
      onClose();
   };

   const handleDelete = async () => {
      // if (!id) {
      //    toast.warn(t("common.select-a-row-first"));
      //    return;
      // }

      const payload = {
         langId: localStorage.getItem("i18nextLngId"),
         eventVisitorId: id,
      };
      try {
         show();
         const response = await deleteEventsVisitor(payload);

         // ✅ Kiểm tra status 200 thay vì message
         if (response?.status === 200) {
            toast.success(t('common.delete-participants-successfully'));
            onRefresh?.();
            onClose?.();
         } else {
            toast.error(response?.data?.message || t("common.error"));
         }
      } catch (err) {
         toast.error(err?.response?.data?.message || t("common.network-or-server-error"));
         console.error("Delete visitor event error:", err);
      } finally {
         hide();
      }
      onClose?.();

   };

   return (
      <CustomDialog maxWidth={'sm'} open onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold text-[#1A1D1F]'>{t('common.delete-participant')}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>

         <DialogContent className='!py-0'>
            <div className='py-5'>
               <p className='pb-3'>{t('common.are-you-sure-delete-this-participant')}</p>
            </div>
         </DialogContent>

         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                  <CloseIcon />
                  <p>{t('button.cancel')}</p>
               </ControlpanelSecondaryButton>
               {/* <ControlpanelPrimaryButton onClick={handleRemoveUser}>
                  <CheckIcon />
                  <p>{t('button.ok')}</p>
               </ControlpanelPrimaryButton> */}
               <ControlpanelPrimaryButton onClick={handleDelete}>
                  <CheckIcon />
                  <p>{t('button.ok')}</p>
               </ControlpanelPrimaryButton>
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default RemoveUserDialog;
